import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getOffer } from "@/lib/api";

export function useOffer() {
  return useQuery({ queryKey: ["offer"], queryFn: getOffer, refetchInterval: 15000 });
}

export function OfferBar() {
  const items = (
    <>
      <span>★ MÁSTER COMPLETO EN IA</span><span className="sep">◆</span>
      <span>PAGO ÚNICO <b>2.900 €</b> · ACCESO DE POR VIDA</span><span className="sep">◆</span>
      <span>MENTORÍAS SEMANALES + COMUNIDAD VIP</span><span className="sep">◆</span>
      <span>PLAZAS <b>LIMITADAS</b></span><span className="sep">◆</span>
    </>
  );
  return (
    <div className="offer-bar" aria-label="Oferta de lanzamiento" data-testid="offer-bar">
      <div className="offer-track">{items}{items}{items}</div>
    </div>
  );
}

export function Countdown() {
  const { data } = useOffer();
  const endMs = data?.fecha_fin_countdown ? new Date(data.fecha_fin_countdown).getTime() : Date.now();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const s = Math.max(0, Math.floor((endMs - now) / 1000));
  const t = {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
  };
  return (
    <div className="countdown" aria-label="La oferta termina pronto" data-testid="countdown">
      {[[t.d, "Días"], [t.h, "Horas"], [t.m, "Min"], [t.s, "Seg"]].map(([v, l]) => (
        <div className="cd" key={l}><b>{String(v).padStart(2, "0")}</b><span>{l}</span></div>
      ))}
    </div>
  );
}

export function PlazasVIP() {
  const { data } = useOffer();
  const total = data?.plazas_total ?? 100;
  const restantes = data?.plazas_restantes ?? 37;
  const pct = ((total - restantes) / total) * 100;
  return (
    <div className="plazas" data-testid="plazas-vip">
      <div className="plazas-top">
        <b>Quedan {restantes} de {total} plazas</b>
        <span>{Math.round(pct)}% ocupado</span>
      </div>
      <div className="plazas-bar"><i style={{ width: `${pct}%` }} /></div>
    </div>
  );
}
